import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormColorService {

  color$: Observable<any>;
  private colorSubject: Subject<any>;

  constructor() {
    this.colorSubject = new Subject<any>();
    this.color$ = this.colorSubject.asObservable();
  }

  static COLOR_WHITE = '#ffffff';

  color = {
    background: '',
    backgroundDark: '',
  };

  updateBackground() {
    let backgroundColor = this.color.background;
    if (localStorage.getItem('theme') === 'dark') {
      backgroundColor = this.color.backgroundDark;
    }

    this.colorSubject.next({ background: backgroundColor });
  }

  setColor(formColor) {
    this.color.background = formColor;
    this.updateBackground();
  }

  setColorDark(formColorDark) {
    this.color.backgroundDark = formColorDark;
    this.updateBackground();
  }
  
  setBackgroundColor() {
    this.setColor(FormColorService.COLOR_WHITE);
  }

}
